import { Link } from "react-router-dom";
import React from "react";

function TestimonialSection() {
  return (
    <div>
      <div className="testimonial-section style-two">
        <div className="divider"></div>

        <div className="container">
          <div className="row g-4 g-lg-5 align-items-end justify-content-between">
            <div className="col-12 col-sm-6 col-lg-5">
              <div className="section-heading">
                <div className="sub-title text-white">
                  <img src="assets/img/core-img/hammer.png" alt="" />
                  Testimonial
                </div>
                <h2 className="text-white mb-0">
                  A Few of Our Client's Comments
                </h2>
              </div>
            </div>

            <div className="col-12 col-sm-6 col-lg-5">
              <div className="text-sm-end">
                <Link to="#" className="btn btn-primary mt-4">
                  <span>
                    View All <i className="ti ti-arrow-up-right"></i>
                  </span>
                  <span>
                    View All <i className="ti ti-arrow-up-right"></i>
                  </span>
                </Link>
              </div>
            </div>
          </div>
        </div>

        <div className="divider-sm"></div>

        <div className="container">
          <div className="testimonial-slide">
            <div className="swiper testimonial-swiper-two style-two">
              <div className="swiper-wrapper">
                {/* Testimonial Slide */}
                <div className="swiper-slide">
                  <div className="testimonial-stars mb-2">
                    <i className="ti ti-star-filled"></i>
                    <i className="ti ti-star-filled"></i>
                    <i className="ti ti-star-filled"></i>
                    <i className="ti ti-star-filled"></i>
                    <i className="ti ti-star-filled"></i>
                  </div>
                  <p className="mb-4 text-white">
                    “He quickly delivered excellent design a per required
                    specifications. New landing page will have refreshing simple
                    look, while keeping page load light on images.”
                  </p>
                  <div className="testimonial-author-info d-flex align-items-center gap-3">
                    <img src="assets/img/bg-img/29.jpg" alt="" />
                    <div>
                      <div>Peggy Thompson</div>
                      <p className="mb-0">Product Manager</p>
                    </div>
                  </div>
                </div>

                {/* Testimonial Slide */}
                <div className="swiper-slide">
                  <div className="testimonial-stars mb-2">
                    <i className="ti ti-star-filled"></i>
                    <i className="ti ti-star-filled"></i>
                    <i className="ti ti-star-filled"></i>
                    <i className="ti ti-star-filled"></i>
                    <i className="ti ti-star-filled"></i>
                  </div>
                  <p className="mb-4 text-white">
                    “He quickly delivered excellent design a per required
                    specifications. New landing page will have refreshing simple
                    look, while keeping page load light on images.”
                  </p>
                  <div className="testimonial-author-info d-flex align-items-center gap-3">
                    <img src="assets/img/bg-img/30.jpg" alt="" />
                    <div>
                      <div>Alexander Cameron</div>
                      <p className="mb-0">Director</p>
                    </div>
                  </div>
                </div>

                {/* Testimonial Slide */}
                <div className="swiper-slide">
                  <div className="testimonial-stars mb-2">
                    <i className="ti ti-star-filled"></i>
                    <i className="ti ti-star-filled"></i>
                    <i className="ti ti-star-filled"></i>
                    <i className="ti ti-star-filled"></i>
                    <i className="ti ti-star-filled"></i>
                  </div>
                  <p className="mb-4 text-white">
                    “He quickly delivered excellent design a per required
                    specifications. New landing page will have refreshing simple
                    look, while keeping page load light on images.”
                  </p>
                  <div className="testimonial-author-info d-flex align-items-center gap-3">
                    <img src="assets/img/bg-img/31.jpg" alt="" />
                    <div>
                      <div>Samantha Brooks</div>
                      <p className="mb-0">CEO & Founder</p>
                    </div>
                  </div>
                </div>

                {/* Testimonial Slide */}
                <div className="swiper-slide">
                  <div className="testimonial-stars mb-2">
                    <i className="ti ti-star-filled"></i>
                    <i className="ti ti-star-filled"></i>
                    <i className="ti ti-star-filled"></i>
                    <i className="ti ti-star-filled"></i>
                    <i className="ti ti-star-filled"></i>
                  </div>
                  <p className="mb-4 text-white">
                    “He quickly delivered excellent design a per required
                    specifications. New landing page will have refreshing simple
                    look, while keeping page load light on images.”
                  </p>
                  <div className="testimonial-author-info d-flex align-items-center gap-3">
                    <img src="assets/img/bg-img/29.jpg" alt="" />
                    <div>
                      <div>Peggy Thompson</div>
                      <p className="mb-0">Product Manager</p>
                    </div>
                  </div>
                </div>

                {/* Testimonial Slide */}
                <div className="swiper-slide">
                  <div className="testimonial-stars mb-2">
                    <i className="ti ti-star-filled"></i>
                    <i className="ti ti-star-filled"></i>
                    <i className="ti ti-star-filled"></i>
                    <i className="ti ti-star-filled"></i>
                    <i className="ti ti-star-filled"></i>
                  </div>
                  <p className="mb-4 text-white">
                    “He quickly delivered excellent design a per required
                    specifications. New landing page will have refreshing simple
                    look, while keeping page load light on images.”
                  </p>
                  <div className="testimonial-author-info d-flex align-items-center gap-3">
                    <img src="assets/img/bg-img/30.jpg" alt="" />
                    <div>
                      <div>Alexander Cameron</div>
                      <p className="mb-0">Director</p>
                    </div>
                  </div>
                </div>

                {/* Testimonial Slide */}
                <div className="swiper-slide">
                  <div className="testimonial-stars mb-2">
                    <i className="ti ti-star-filled"></i>
                    <i className="ti ti-star-filled"></i>
                    <i className="ti ti-star-filled"></i>
                    <i className="ti ti-star-filled"></i>
                    <i className="ti ti-star-filled"></i>
                  </div>
                  <p className="mb-4 text-white">
                    “He quickly delivered excellent design a per required
                    specifications. New landing page will have refreshing simple
                    look, while keeping page load light on images.”
                  </p>
                  <div className="testimonial-author-info d-flex align-items-center gap-3">
                    <img src="assets/img/bg-img/31.jpg" alt="" />
                    <div>
                      <div>Samantha Brooks</div>
                      <p className="mb-0">CEO & Founder</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="testimonial-pagination style-two"></div>
        </div>

        <div className="divider"></div>
      </div>
    </div>
  );
}

export default TestimonialSection;
